// extracted by mini-css-extract-plugin
export default {"ImageArea":"ImageGallery_ImageArea__Xyx-f","ImageAreaHeading":"ImageGallery_ImageAreaHeading__1aqG0","gallery":"ImageGallery_gallery__iK3au","message":"ImageGallery_message__PFpnd"};